import forEach from '@Utils/forEach'

export default class UserProfiileLink {
  constructor () {
    forEach(document.querySelectorAll('[data-role="user-profile-link"]'), (i, el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        App.dispatcher.fire('user-profile.open')
      })
    })
  }
}
